export const CoreState: any = { isLoading: !0, showloading: !1, showheader: !0 };
